import { ReferrerContext } from '@amzn/aapn-react-components'
import React, { useContext } from 'react'
import { CrowdSurfConfig, CrowdSurfConfigContext } from 'util/appconfig'
import { MetricsInjector } from '@amzn/aapn-front-end-metrics'
import { RouteComponentProps } from 'react-router-dom'
import KatalMetricObject from '@amzn/katal-metrics/lib/metricObject/KatalMetricObject'
import { LopContext } from '../../util/language_preference_provider/language_preference_provider'
import { Metric } from '@amzn/katal-metrics'
import { SearchRefContext } from 'util/search_ref_provider/search_ref_provider'

export const Metrics: React.FunctionComponent<React.PropsWithChildren<RouteComponentProps>> = (
  props: React.PropsWithChildren<RouteComponentProps>,
): JSX.Element => {
  const config = useContext<CrowdSurfConfig>(CrowdSurfConfigContext)
  const lop = useContext(LopContext)
  const refTag = useContext(ReferrerContext).refTag
  const searchRefTag = useContext(SearchRefContext).searchRefTag

  const fetchRelatedMetrics = (): KatalMetricObject[] => {
    const bodyData = document.body.dataset
    const entityId = bodyData['entityId']
    const entityMpId = bodyData['entityMpId']
    const advertiserId = bodyData['advertiserId']

    return [
      new Metric.String('entity_id', entityId ?? ''),
      new Metric.String('entity_mp_id', entityMpId ?? ''),
      new Metric.String('advertiser_id', advertiserId ?? ''),
      new Metric.Counter('advertiser_recognized', advertiserId ? 1 : 0),
      new Metric.String('locale', lop.lop),
      new Metric.String('refTag', refTag),
      new Metric.String('searchRefTag', searchRefTag ?? ''),
    ]
  }

  return <MetricsInjector pathname={props.location.pathname} {...config.metricsEndpoint} relatedMetrics={fetchRelatedMetrics} />
}
